/* eslint-disable no-new, quote-props */
import $ from 'jquery';
import Vue from 'vue';
import VueLightbox from './mixins/sk-lightbox-vue';
import HeaderPromo from './components/sk-header-promo.vue';
import UiLightbox from './components/sk-ui-lightbox.vue';
import UiLightboxButton from './components/sk-ui-lightbox-button.vue';
import UiLightboxClose from './components/sk-ui-lightbox-close.vue';
import UiLightboxWrapper from './components/sk-ui-lightbox-wrapper.vue';
import Marketo from './components/sk-marketo.vue';
import HeaderEmailSignup from './components/sk-header-email-signup.vue';
import UiSupportSearchBox from './components/sk-support-search-box.vue';
import UiSupportSearchResults from './components/sk-support-search-results.vue';
import UiSupportFaq from './components/sk-faq.vue';
import HeaderMobile from '../twig/vue/components/header/HeaderMobile.vue';
import StickyStarterNav from '../twig/vue/components/nav/StickyStarterNav.vue';
import RandomNotificationBanner from '../twig/vue/components/header/RandomNotificationBanner.vue';
import SupportLogin from './components/sk-support-login.vue';
import SupportFaqSidebar from './components/sk-support-faq-sidebar.vue';
import AnchorLink from './components/sk-anchor-link.vue';
import LightspeedMessage from '../twig/vue/components/lightspeed/LightspeedMessage.vue';
import animations from '../lib/sk-animations';

// Importing component from new set up

const vm = {
  init() {
    new Vue({
      el: '#vue-root',
      mixins: [VueLightbox],
      components: {
        Marketo,
        UiLightbox,
        UiLightboxButton,
        UiLightboxClose,
        UiLightboxWrapper,
        HeaderPromo,
        UiSupportSearchBox,
        UiSupportSearchResults,
        UiSupportFaq,
        HeaderMobile,
        StickyStarterNav,
        RandomNotificationBanner,
        HeaderEmailSignup,
        SupportLogin,
        SupportFaqSidebar,
        AnchorLink,
        LightspeedMessage
      },
      data: {
        lightboxCta: '',
        lightboxToggled: '',
        lightboxOnClose: '',
        lightboxEscapeListener: '',
        lightboxFormType: '',
        marketoInitialStep: '',
        marketoCurrentStep: '',
        marketoStepResumed: false,
        binaryOptionVisible: false,
        marketoCountForms: 0,
        marketoCurrentStepId: '',
        marketoFormChanged: false,
        shouldShowBlogSearch: false
      },
      mounted() {
        if (
          window.location.pathname.match(/^\/support/) &&
          window.location.hash.match(/^#.+/)
        ) {
          setTimeout(() => {
            animations.easedAnchorScroll(
              $(document.body),
              $(window.location.hash),
              100,
              150
            );
          }, 2000);
        }
      }
    });
  }
};

export default vm;
